<div class="wrap-livesale-card">
    <div class="card-inner-wrap">
        <p *ngFor="let sale of liveSaleList">{{sale.content}}&nbsp;<span class="time-zone">({{sale.timeAgo }})</span></p>
    </div>
</div>